module.exports = __webpack_public_path__ + "static/media/percent.79bcf556.svg";